import { createContext, useContext } from 'react';

/**
 * Colour overrides a flow applies to every sheet rendered inside it: the
 * `BottomSheet` surface and title, and the `useSheetTokens()` values its
 * content reads. Unset keys keep the app defaults. Providers pass `null` in
 * dark mode so dark sheets are never restyled by a light-only palette.
 *
 * Lives on its own (not in ProfileSheetScaffold) so `BottomSheet` can read it
 * without importing the profile sheet scaffolding.
 */
export interface SheetPaletteOverride {
  /** Sheet surface (`BottomSheet` background, `tokens.pageBg` / `tokens.bg`). */
  pageBg?: string;
  /** Primary text, including the `BottomSheet` title. */
  text?: string;
  textSecondary?: string;
  textTertiary?: string;
  /** Card / input surface. */
  inputBg?: string;
  /** Card / input border. */
  inputBorder?: string;
  hairline?: string;
}

export const SheetPaletteContext = createContext<SheetPaletteOverride | null>(
  null,
);

export function useSheetPaletteOverride(): SheetPaletteOverride | null {
  return useContext(SheetPaletteContext);
}
